import React from "react";
import "./styles.scss";
import { Switch, Route } from "react-router-dom";
import Single from "./Single";
import Podcast from "./Podcast";
import NewAlbum from "./Album/NewAlbum";
import UploadTracks from "./Album/UploadTracks";
import AlbumTracksEdit from "./Album/AlbumTracksEdit";
import DoneUploading from "./DoneUploading";

function Upload() {
  return (
    <div id="upload">
      <Switch>
        <Route path="/upload/done" exact component={DoneUploading} />
        <Route path="/upload/podcast" exact component={Podcast} />
        <Route path="/upload/single" exact component={Single} />
        <Route path="/upload/albums/new" exact component={NewAlbum} />
        <Route
          path="/upload/albums/:album_id/upload_tracks"
          component={UploadTracks}
          exact
        />
        <Route
          path="/upload/albums/:album_id/edit_tracks"
          component={AlbumTracksEdit}
          exact
        />
      </Switch>
    </div>
  );
}

export default Upload;
